import { hotRanking } from "@/mocks/homeData";

const rankStyle = (rank: number) => {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-primary-300 text-foreground-950";
  if (rank === 3) return "bg-accent-500 text-background-50";
  return "bg-background-200 text-foreground-700";
};

export default function HotSidebar() {
  return (
    <aside className="flex flex-col gap-5 lg:sticky lg:top-24">
      <div className="rounded-lg border border-background-200/80 bg-background-50 overflow-hidden">
        <div className="flex items-center gap-2.5 border-b border-background-200/70 px-5 py-4">
          <span className="w-9 h-9 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center text-lg">
            <i className="ri-fire-line"></i>
          </span>
          <h3 className="font-heading text-lg font-bold text-foreground-950">热榜速览</h3>
        </div>
        <ol className="p-2">
          {hotRanking.map((item) => (
            <li key={item.rank}>
              <a
                href="#feed"
                className="flex items-center gap-3 rounded-md px-3 py-2.5 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span
                  className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${rankStyle(item.rank)}`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 min-w-0 text-sm text-foreground-800 truncate">{item.title}</span>
                <span className="shrink-0 text-xs text-foreground-500">{item.heat}</span>
              </a>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
        <span className="w-12 h-12 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-2xl">
          <i className="ri-send-plane-fill"></i>
        </span>
        <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">有料要曝？</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
          走官方投稿爆料入口，支持匿名提交，材料加密保存，24 小时内给出回执。
        </p>
        <a
          href="#submit"
          className="mt-4 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
        >
          <span>查看投稿流程</span>
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6">
        <div className="flex items-center gap-2 text-sm font-medium text-accent-700">
          <i className="ri-shield-check-line"></i>
          <span>官方提醒</span>
        </div>
        <p className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-600">
          客服不会主动私信索要费用。任何要求转账或下载附件的“官方”，都请先通过本页邮箱核实。
        </p>
      </div>
    </aside>
  );
}